export const isDev = process.env.NODE_ENV === 'development';

export function wait(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
